import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { EMAIL_LOCALES } from "@fysaro/shared";

// Importación de Namespaces (Feature-based)
import commonEs from "./locales/es/common.json";
import errorsEs from "./locales/es/errors.json";
import regionsEs from "./locales/es/regions.json";
// Tenant
import availabilityEs from "./locales/es/tenant/availability.json";
import exceptionEs from "./locales/es/tenant/exception.json";
import blockedEs from "./locales/es/tenant/blocked.json";
import servicesEs from "./locales/es/tenant/services.json";
import serviceCategoriesEs from "./locales/es/tenant/service-categories.json";
import clinicSettingsEs from "./locales/es/tenant/clinic-settings.json";
import specialtiesEs from "./locales/es/tenant/specialties.json";
import exercisesEs from "./locales/es/tenant/exercises.json";
import protocolsEs from "./locales/es/tenant/protocols.json";
import exerciseCategoriesEs from "./locales/es/tenant/exercise-categories.json";
import clinicEs from "./locales/es/tenant/clinic.json";
import patientEs from "./locales/es/tenant/patient.json";
import professionalEs from "./locales/es/tenant/professional.json";
import planEs from "./locales/es/tenant/plan.json";
import dashboardEs from "./locales/es/tenant/dashboard.json";
import invitationEs from "./locales/es/tenant/invitation.json";
import staffEs from "./locales/es/tenant/staff.json";
import bookingEs from "./locales/es/tenant/booking.json";
//Landing
import landingEs from "./locales/es/public/landing.json";
//Auth
import authEs from "./locales/es/auth/auth.json";
//Patient
import dashPatientEs from "./locales/es/patient/dash-patient.json";
import clinicPatientEs from "./locales/es/patient/clinic-patient.json";
import layoutPatientEs from "./locales/es/patient/layout-patient.json";
import bookingPatientEs from "./locales/es/patient/booking-patient.json";
import profilePatientEs from "./locales/es/patient/profile-patient.json";
import helpArticlesEs from "./locales/es/help-articles.json";
import platformCatalogEs from "./locales/es/platform-catalog.json";


import commonEn from "./locales/en/common.json";
import errorsEn from "./locales/en/errors.json";
import regionsEn from "./locales/en/regions.json";
// Tenant
import availabilityEn from "./locales/en/tenant/availability.json";
import exceptionEn from "./locales/en/tenant/exception.json";
import blockedEn from "./locales/en/tenant/blocked.json";
import servicesEn from "./locales/en/tenant/services.json";
import serviceCategoriesEn from "./locales/en/tenant/service-categories.json";
import clinicSettingsEn from "./locales/en/tenant/clinic-settings.json";
import specialtiesEn from "./locales/en/tenant/specialties.json";
import exercisesEn from "./locales/en/tenant/exercises.json";
import protocolsEn from "./locales/en/tenant/protocols.json";
import exerciseCategoriesEn from "./locales/en/tenant/exercise-categories.json";
import clinicEn from "./locales/en/tenant/clinic.json";
import patientEn from "./locales/en/tenant/patient.json";
import professionalEn from "./locales/en/tenant/professional.json";
import planEn from "./locales/en/tenant/plan.json";
import dashboardEn from "./locales/en/tenant/dashboard.json";
import invitationEn from "./locales/en/tenant/invitation.json";
import staffEn from "./locales/en/tenant/staff.json";
import bookingEn from "./locales/en/tenant/booking.json";
//Landing
import landingEn from "./locales/en/public/landing.json";
//Auth
import authEn from "./locales/en/auth/auth.json";
//Patient
import dashPatientEn from "./locales/en/patient/dash-patient.json";
import clinicPatientEn from "./locales/en/patient/clinic-patient.json";
import layoutPatientEn from "./locales/en/patient/layout-patient.json";
import bookingPatientEn from "./locales/en/patient/booking-patient.json";
import profilePatientEn from "./locales/en/patient/profile-patient.json";
import helpArticlesEn from "./locales/en/help-articles.json";
import platformCatalogEn from "./locales/en/platform-catalog.json";


import commonIt from "./locales/it/common.json";
import errorsIt from "./locales/it/errors.json";
import regionsIt from "./locales/it/regions.json";
// Tenant
import availabilityIt from "./locales/it/tenant/availability.json";
import exceptionIt from "./locales/it/tenant/exception.json";
import blockedIt from "./locales/it/tenant/blocked.json";
import servicesIt from "./locales/it/tenant/services.json";
import serviceCategoriesIt from "./locales/it/tenant/service-categories.json";
import clinicSettingsIt from "./locales/it/tenant/clinic-settings.json";
import specialtiesIt from "./locales/it/tenant/specialties.json";
import exercisesIt from "./locales/it/tenant/exercises.json";
import protocolsIt from "./locales/it/tenant/protocols.json";
import exerciseCategoriesIt from "./locales/it/tenant/exercise-categories.json";
import clinicIt from "./locales/it/tenant/clinic.json";
import patientIt from "./locales/it/tenant/patient.json";
import professionalIt from "./locales/it/tenant/professional.json";
import planIt from "./locales/it/tenant/plan.json";
import dashboardIt from "./locales/it/tenant/dashboard.json";
import invitationIt from "./locales/it/tenant/invitation.json";
import staffIt from "./locales/it/tenant/staff.json";
import bookingIt from "./locales/it/tenant/booking.json";
//Landing
import landingIt from "./locales/it/public/landing.json";
//Auth
import authIt from "./locales/it/auth/auth.json";
//Patient
import dashPatientIt from "./locales/it/patient/dash-patient.json";
import clinicPatientIt from "./locales/it/patient/clinic-patient.json";
import layoutPatientIt from "./locales/it/patient/layout-patient.json";
import bookingPatientIt from "./locales/it/patient/booking-patient.json";
import profilePatientIt from "./locales/it/patient/profile-patient.json";
import helpArticlesIt from "./locales/it/help-articles.json";
import platformCatalogIt from "./locales/it/platform-catalog.json";


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        //Inyectas dinámicamente todo lo que venga en shared para español (email e invoice)
        ...EMAIL_LOCALES.es,
        common: commonEs,
        errors: errorsEs,
        regions: regionsEs,
        auth: authEs,
        availability: availabilityEs,
        exception: exceptionEs,
        blocked: blockedEs,
        services: servicesEs,
        "service-categories": serviceCategoriesEs,
        specialties: specialtiesEs,
        exercises: exercisesEs,
        protocols: protocolsEs,
        "exercise-categories": exerciseCategoriesEs,
        clinic: clinicEs,
        "clinic-settings": clinicSettingsEs,
        "clinic-patient": clinicPatientEs,
        "layout-patient": layoutPatientEs,
        patient: patientEs,
        professional: professionalEs,
        plan: planEs,
        dashboard: dashboardEs,
        "dash-patient": dashPatientEs,
        invitation: invitationEs,
        staff: staffEs,
        booking: bookingEs,
        "booking-patient": bookingPatientEs,
        "profile-patient": profilePatientEs,
        landing: landingEs,
        "help-articles": helpArticlesEs,
        "platform-catalog": platformCatalogEs,
      },
      en: {
        //Inyectas dinámicamente todo lo que venga en shared para ingles (email e invoice)
        ...EMAIL_LOCALES.en,
        common: commonEn,
        errors: errorsEn,
        regions: regionsEn,
        auth: authEn,
        availability: availabilityEn,
        exception: exceptionEn,
        blocked: blockedEn,
        services: servicesEn,
        "service-categories": serviceCategoriesEn,
        specialties: specialtiesEn,
        exercises: exercisesEn,
        protocols: protocolsEn,
        "exercise-categories": exerciseCategoriesEn,
        clinic: clinicEn,
        "clinic-settings": clinicSettingsEn,
        "clinic-patient": clinicPatientEn,
        "layout-patient": layoutPatientEn,
        patient: patientEn,
        professional: professionalEn,
        plan: planEn,
        dashboard: dashboardEn,
        "dash-patient": dashPatientEn,
        invitation: invitationEn,
        staff: staffEn,
        booking: bookingEn,
        "booking-patient": bookingPatientEn,
        "profile-patient": profilePatientEn,
        landing: landingEn,
        "help-articles": helpArticlesEn,
        "platform-catalog": platformCatalogEn,
      },
      it: {
         //Inyectas dinámicamente todo lo que venga en shared para ingles (email e invoice)
         ...EMAIL_LOCALES.it,
        common: commonIt,
        errors: errorsIt,
        regions: regionsIt,
        auth: authIt,
        availability: availabilityIt,
        exception: exceptionIt,
        blocked: blockedIt,
        services: servicesIt,
        "service-categories": serviceCategoriesIt,
        specialties: specialtiesIt,
        exercises: exercisesIt,
        protocols: protocolsIt,
        "exercise-categories": exerciseCategoriesIt,
        clinic: clinicIt,
        "clinic-settings": clinicSettingsIt,
        "clinic-patient": clinicPatientIt,
        "layout-patient": layoutPatientIt,
        patient: patientIt,
        professional: professionalIt,
        plan: planIt,
        dashboard: dashboardIt,
        "dash-patient": dashPatientIt,
        invitation: invitationIt,
        staff: staffIt,
        booking: bookingIt,
        "booking-patient": bookingPatientIt,
        "profile-patient": profilePatientIt,
        landing: landingIt,
        "help-articles": helpArticlesIt,
        "platform-catalog": platformCatalogIt,
      },
    },
    fallbackLng: "es",
    load: "languageOnly", // Evita fugas y avisos buscando "es-ES" o "en-GB"
    supportedLngs: ["es", "en", "it"], // Define tu catálogo oficial de idiomas cortos
    ns: [
      "common",
      "errors",
      "regions",
      "email",
      "auth",
      "availability",
      "exception",
      "blocked",
      "services",
      "service-categories",
      "specialties",
      "exercises",
      "protocols",
      "exercise-categories",
      "clinic",
      "clinic-settings",
      "clinic-patient",
      "layout-patient",
      "patient",
      "professional",
      "plan",
      "dashboard",
      "dash-patient",
      "invitation",
      "invoice",
      "staff",
      "booking",
      "booking-patient",
      "profile-patient",
      "landing",
      "help-articles",
      "platform-catalog",
    ],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
  });

export default i18n;
